import { VariantWithImage } from '../../../types'

type TrackingInfo = {
    productName: string
    categoryName: string
    contentIds: string[]
}

// TODO: Do we need to support this anymore?
export const getTrackingInfo = (
    link: VariantWithImage,
): TrackingInfo | null => {
    switch (`${link.link.shopifyId}`) {
        // Dosaze Pillow
        case '4516914987146':
            return {
                productName: `The Dosaze Contoured Orthopedic Pillow - ${link.title}`,
                categoryName: 'Pillows',
                contentIds: ['8256883196139'],
            }
        default:
            return null
    }
}
